import HttpClient from '@/utils/HttpClient';
import projectStore from '@/store/Projects';

export default {
  getSummary() {
    return HttpClient.getAuthenticated(`/api/projects/${projectStore.activeProject.DbId}/budgetsummary`);
  }
};
